import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getVendorGradeListApi = async (params) => {
  try {
    return await get("grade", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitVendorGradeApi = async (body) => {
  try {
    return await post("grade", body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const deleteVendorGradeListApi = async (id) => {
  try {
    return await del(`grade/delete/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getVendorGradeByIdApi = async (id) => {
  try {
    return await get(`grade/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateVendorGradeListApi = async (id, body) => {
  try {
    return await put(`grade/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const bulkDeleteVendorGradeApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    return await del("grade/bulk_delete", data);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
